import React, { useState, useEffect, useMemo } from 'react';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { tableTheme, tableThemeStatic } from '../../helpers/tableTheme';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import {
  approveWithdrawlRequest,
  getPendingWithdrawlRequest,
} from '../../redux/actions/notification';
import { Spinner, Modal, Button } from '@themesberg/react-bootstrap';

function WithdrawlRequests({ history }) {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeTransId, setActiveTransId] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSuccess = () => {
    setIsSubmitting(false);
    handleCloseModal();
    setIsLoading(true);
    dispatch(getPendingWithdrawlRequest()).then(() => setIsLoading(false));
  };
  const handleFailure = () => {
    setIsSubmitting(false);
  };

  const submitHandler = () => {
    setIsSubmitting(true);
    dispatch(
      approveWithdrawlRequest(activeTransId, handleSuccess, handleFailure)
    );
  };

  const withdrawlRequestData = useSelector(
    (state) => state.notification.withdrawlRequestData
  );

  const columns = [
    {
      name: 'Transaction Id',
      label: 'Transaction Id',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'Customer Id',
      label: 'Customer Id',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'Customer Name',
      label: 'Customer Name',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'Amount',
      label: 'Amount',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'Requested On',
      label: 'Requested On',
      options: {
        filter: false,
        sort: true,
      },
    },
    'Assigned Collector',
    {
      name: 'Action',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            variant='primary'
            size='sm'
            disabled={isSubmitting}
            onClick={() => {
              setActiveTransId(value);
              handleShowModal();
            }}
          >
            {/* {isSubmitting === true ? <Spinner animation="border" /> : "Approve"} */}
            Approve
          </Button>
        ),
      },
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    dispatch(getPendingWithdrawlRequest()).then(() => setIsLoading(false));
  }, []);

  // const onRowsSelect = (rowData, rowMeta) => {
  //   // history.push(`/collectors/profile/${rowData[0]}`);
  // };
  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: false,
    // onRowClick: onRowsSelect,
    responsive: 'standard',
    print: false,
    download: false,
  };

  return (
    <div>
      <MuiThemeProvider theme={tableThemeStatic}>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <>
            {/* Modal Here */}
            <Modal
              show={showModal}
              onHide={handleCloseModal}
              backdrop={isSubmitting ? 'static' : 'true'}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirm Action</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h6>Approve this withdraw request?</h6>
              </Modal.Body>
              <Modal.Footer>
                <Button variant='danger' onClick={handleCloseModal}>
                  Cancel
                </Button>
                <Button
                  variant='primary'
                  onClick={submitHandler}
                  disabled={isSubmitting}
                >
                  {isSubmitting === true ? (
                    <Spinner animation='border' />
                  ) : (
                    'Approve'
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
            <MUIDataTable
              title={'Incoming Withdrawl Requests'}
              data={withdrawlRequestData}
              columns={columns}
              options={options}
            />
          </>
        )}
      </MuiThemeProvider>
    </div>
  );
}

export default WithdrawlRequests;
